<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Indicador</h4>
                <div class="table-responsive">
                    <table id="tblData" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th>Sucursal</th>
                                <th>Nombre/RazonSocial</th>
                                <th>Encargado</th>
                                <th>Fecha Peticion</th>
                                <th>Procedimiento</th>
                                <th>Autorizacion</th>
                                <th>Fecha Respuesta (minutos)</th>
                                <th>Tiempo Respuesta</th>
                                <th>Observaciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let i of arrayIndicador" style="text-align: center">
                                <td>{{i.sucursal}}</td>
                                <td>{{i.nombre}}</td>
                                <td>{{i.analista}}</td>
                                <td>{{i.fechaCreacion}}</td>
                                <td>{{i.concepto}}</td>
                                <td>{{i.autorizacion}}</td>
                                <td>{{i.fechaAutorizacion}}</td>
                                <td>{{i.tiempoRespuesta}}</td>
                                <td>hola</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>
                <button class="btn btn-success" (click)="exportTableToExcel('tblData', 'indicadorCI')">Exportar datos a Excel</button>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/indicadores/control-interno/control-interno.component.html